// src/app/App.jsx
import { Box, Container } from "@mui/material";
import NavBar from "../shared/components/NavBar";
import AppRoutes from "./router";
import Footer from "../shared/components/Footer";
import ScrollToTop from "../shared/components/ScrollTop";
import ResultsRoutes from "./resultsRoutes";



export default function App() {
  return (
    <Box sx={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
    }}>
      <NavBar />
      <Container maxWidth={false} disableGutters sx={{ px: 0, py: 0, flex: 1 }}>
        <ScrollToTop />
        <AppRoutes />
        <ResultsRoutes />
      </Container>
      <Footer />
    </Box>
  );
}
